package one.healthium.onboarding.ui.utils

import one.healthium.base.utils.kgToLb
import one.healthium.base.utils.lbToKg
import one.healthium.base.utils.toStringOrEmpty
import one.healthium.onboarding.ui.models.WeightUnit


fun Float?.ensureKg(srcUnit: WeightUnit): Float {
    if (this == null || this == 0f) return 0f
    return when (srcUnit) {
        WeightUnit.Kg -> this
        WeightUnit.Lb -> this.lbToKg()
    }
}

fun Float?.toUnitString(unit: WeightUnit, addUnit: Boolean = false): String {
    if (this == null || this == 0f) return ""
    return when (unit) {
        WeightUnit.Kg -> this.toInt().toStringOrEmpty().addUnitIf(unit, addUnit)
        WeightUnit.Lb -> this.kgToLb().toInt().toStringOrEmpty().addUnitIf(unit, addUnit)
    }
}

fun String.addUnitIf(unit: WeightUnit, addUnit: Boolean): String {
    return if (addUnit && isNotEmpty()) {
        "$this ${unit.displayValue()}"
    } else {
        this
    }
}
